import { Plus } from 'lucide-react';
import JobsStats from './JobsStats';
import JobsList, { JobsFilter } from './JobsList';
import PageWithTable from '@/src/Common/components/PageWithTable';
import { useState } from 'react';
import { Button } from '@/src/shadComponents/ui/button';

const secondaryNavigation = [
    { name: 'All', key: 'all', href: '#', current: true },
    { name: 'Mine', key: 'mine', href: '#', current: false },
    { name: 'Next 30 Days', key: 'next30', href: '#', current: false },
    { name: 'Past', key: 'previous30', href: '#', current: false },
];

export default function JobsDashboard() {
    const [filter, setFilter] = useState<JobsFilter>('all');
    const actions = (
        <Button asChild className="ml-auto">
            <a href="jobs/create">
                <Plus className="-ml-1.5 size-5" aria-hidden="true" />
                Create Job
            </a>
        </Button>
    );
    return (
        <PageWithTable
            title="Jobs"
            breadcrumbs={[{ label: 'Jobs' }]}
            filters={secondaryNavigation.map((item) => (
                <a
                    key={item.name}
                    href={item.href}
                    className={
                        item.key === filter
                            ? 'text-foreground font-semibold border-b-2 border-primary'
                            : 'text-foreground'
                    }
                    onClick={(e) => {
                        e.preventDefault();
                        setFilter(item.key as JobsFilter);
                    }}
                >
                    {item.name}
                </a>
            ))}
            actions={actions}
        >
            <JobsStats />
            <JobsList filter={filter} />
        </PageWithTable>
    );
}
